import * as types from '../types';

const initialState = {
    header_transparent: false,
    header_simple: false,
    footer_white: false
};

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case types.HEADER_TO_TRANSPARENT:
            return { ...state, header_transparent: action.payload };

        case types.HEADER_TO_SIMPLE:
            return { ...state, header_simple: action.payload };

        case types.FOOTER_TO_WHITE:
            return { ...state, footer_white: action.payload };

        default:
            return { ...state };
    }

}

export default reducer;
